// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"b2adc66992b44f72d745","339":"4e823b97afb8232dc6c6"}[chunkId] + ".js";
};